var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { PageService } from '../../models/page.service';
import { MessageService } from '../../service/message.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
import { MenuService } from '../menu/menu.service';
var NaviComponent = /** @class */ (function (_super) {
    __extends(NaviComponent, _super);
    function NaviComponent(router, route, logger, action, message, page, service, menuService, location) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.menuService = menuService;
        _this.location = location;
        _this.defMode = '';
        _this.menupath = [];
        _this.breadcrumbs = [];
        _this.back = false;
        _this.display = true;
        _this.replaceBreadcrumbs = {};
        _this.replaced = false;
        return _this;
    }
    NaviComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.component.params && typeof this.component.params.displayBreadcrumbs !== 'undefined') {
            this.display = this.component.params.displayBreadcrumbs;
        }
    };
    NaviComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (meta.menus) {
            var data = this.menuService.getMenuData(meta.menus);
            this.menupath = data.menupath;
            this.back = data.back;
        }
    };
    NaviComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    NaviComponent.prototype.onSubscribe = function (data) {
        var breadcrumbs = JSON.stringify(this.breadcrumbs);
        for (var _i = 0, _a = Object.keys(this.replaceBreadcrumbs); _i < _a.length; _i++) {
            var replaceKey = _a[_i];
            var dataKey = this.replaceBreadcrumbs[replaceKey];
            var replaceValue = '';
            if (dataKey.match(/^\$/)) {
                replaceValue = jsonpath.value(data, dataKey);
            }
            else {
                replaceValue = data[dataKey];
            }
            if (typeof replaceValue === 'undefined' || replaceValue === null) {
                replaceValue = '';
            }
            var reg = new RegExp(":" + replaceKey, 'g');
            breadcrumbs = breadcrumbs.replace(reg, replaceValue);
        }
        this.breadcrumbs = JSOG.parse(breadcrumbs);
        this.replaced = true;
    };
    NaviComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'back') {
            this.menuService.popUrl();
            this.location.back();
        }
        else if (e2 === 'menu') {
            this.menuService.pushUrl(rec);
            this.router.navigate([rec]);
        }
        else if (e2 === 'breadcrumbs') {
            var compRec = this.action.getCompRec();
            var data = {};
            for (var key in compRec) {
                data = Object.assign({}, data, compRec[key]);
            }
            this.action.setRec(data);
            this.action.firstAction(rec);
        }
    };
    NaviComponent.prototype.setChangeCompData = function (component) {
        this.component.title = component.title;
        this.replaceBreadcrumbs = (this.component.params && this.component.params.replace ? this.component.params.replace : {});
        this.replaced = (Object.keys(this.replaceBreadcrumbs).length > 0 ? false : true);
        var breadcrumbs = (component.params && component.params.breadcrumbs ? component.params.breadcrumbs : []);
        for (var _i = 0, breadcrumbs_1 = breadcrumbs; _i < breadcrumbs_1.length; _i++) {
            var crumbs = breadcrumbs_1[_i];
            if (!this.action.validEvent(crumbs.event)) {
                delete crumbs.event;
            }
        }
        this.breadcrumbs = breadcrumbs;
    };
    NaviComponent.prototype.trackByLabel = function (index, item) {
        return item.label;
    };
    NaviComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'navi',
                    template: "<div *ngIf=\"defMode === '' || defMode === mode\" class=\"pageTtl\" id=\"{{ componentName }}\">\n  <ul *ngIf=\"display && replaced\" class=\"ulHorSlash\">\n    <li *ngFor=\"let menu of menupath; trackBy: trackByLabel\" class=\"ulHorSlash_li\"><!--\n      --><ng-template [ngIf]=\"!menu.url\">{{ menu.label }}</ng-template><!--\n      --><a *ngIf=\"menu.url\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'menu', menu.url)\">{{ menu.label }}</a><!--\n    --></li>\n    <li *ngFor=\"let crumbs of breadcrumbs; trackBy: trackByLabel\" class=\"ulHorSlash_li\"><!--\n      --><ng-template [ngIf]=\"!crumbs.event\">{{ crumbs.label }}</ng-template><!--\n      --><a *ngIf=\"crumbs.event\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'breadcrumbs', crumbs.event)\">{{ crumbs.label }}</a><!--\n    --></li>\n  </ul>\n  <item-plabel [cls]=\"'pageHeading'\" [txt]=\"component.title\"></item-plabel>\n  <p *ngIf=\"back\" class=\"-mt-1 -mb-1\">\n    <item-anchor [txt]=\"(msg | async)['NaviComponent.back']\" [icon]=\"'arrowBack'\" (click)=\"onEvent($event, 'back')\"></item-anchor>\n  </p>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    NaviComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: MenuService },
        { type: Location }
    ]; };
    return NaviComponent;
}(ContentBaseComponent));
export { NaviComponent };
//# sourceMappingURL=navi.component.js.map